<template>
  <div class="page-container">
    <AppSidebar />

    <div class="main-content">
      <div class="static-page">
        <div class="page-header">
          <h1>自审制度</h1>
        </div>

        <div class="content-container">
          <div class="content-text">
            <h2>一、制度目的</h2>
            <p>为保障网站内容安全、规范平台运营秩序、维护用户合法权益，武汉天冉网络科技有限公司建立内容自审制度，对网站发布、展示和传播的信息进行日常审核与管理。</p>
            <ul>
              <li>确保网站内容符合国家法律法规和行业管理要求</li>
              <li>及时发现并处理违法违规、侵权或不良信息</li>
              <li>提升内容质量，为用户提供健康、有序的浏览体验</li>
            </ul>

            <h2>二、审核范围</h2>
            <p>本制度适用于网站内所有公开展示或向用户提供的内容，包括但不限于：</p>
            <ul>
              <li>文字、图片、漫画封面、章节内容及相关介绍信息</li>
              <li>用户提交的反馈、建议、联系方式及其他互动信息</li>
              <li>站内公告、活动说明、帮助文档和声明类页面</li>
              <li>外部链接、广告素材及合作方提供的展示内容</li>
            </ul>

            <h2>三、审核原则</h2>
            <p>内容审核坚持合法合规、客观审慎、分级处理、留痕可查的原则。</p>
            <ul>
              <li>遵守中华人民共和国相关法律法规和监管要求</li>
              <li>尊重知识产权、隐私权、名誉权等合法权益</li>
              <li>对疑似违规内容先行下架或限制展示，再进行复核处理</li>
              <li>对审核过程和处理结果进行必要记录，便于追溯和改进</li>
            </ul>

            <h2>四、禁止内容</h2>
            <p>网站禁止发布、传播或展示以下内容：</p>
            <ul>
              <li>违反国家法律法规、危害国家安全或社会公共利益的内容</li>
              <li>含有暴力、恐怖、色情、赌博、诈骗、迷信等不良信息的内容</li>
              <li>侵犯他人著作权、商标权、肖像权、隐私权等合法权益的内容</li>
              <li>虚假宣传、恶意引流、诱导交易或干扰网站正常运营的内容</li>
              <li>其他违反公序良俗或平台管理规范的内容</li>
            </ul>

            <h2>五、审核流程</h2>
            <p>网站内容审核按照发布前检查、日常巡查、用户反馈和复核处理相结合的方式进行。</p>
            <ul>
              <li>发布前对重要页面、公告和展示内容进行基础合规检查</li>
              <li>日常运营中定期巡查重点页面、热门内容和用户反馈信息</li>
              <li>收到用户投诉或权利通知后，及时核实并采取相应处理措施</li>
              <li>对误判或争议内容进行复核，必要时调整处理结果</li>
            </ul>

            <h2>六、处理措施</h2>
            <p>对发现的问题内容，网站将根据情节轻重采取以下一种或多种措施：</p>
            <ul>
              <li>修改、屏蔽、删除或下架相关内容</li>
              <li>限制相关账号或内容的展示、访问和互动功能</li>
              <li>向内容提供方或相关用户发出整改通知</li>
              <li>对涉嫌违法犯罪的线索，依法配合有关部门处理</li>
            </ul>

            <h2>七、用户监督</h2>
            <p>用户如发现网站内容存在违法违规、侵权或其他不当情形，可通过问题投稿、邮箱或电话向我们反馈。我们将在收到反馈后尽快核实，并根据核实结果进行处理。</p>

            <h2>八、联系方式</h2>
            <p>如对本制度有任何疑问或建议，请通过以下方式联系我们：</p>
            <ul>
              <li>公司名称：武汉天冉网络科技有限公司</li>
              <li>联系电话：13641239621</li>
              <li>电子邮箱：wudongjian@huashi.tv</li>
              <li>公司地址：湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</li>
            </ul>

            <p class="update-time">最后更新时间：2026年6月23日</p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/layout/Sidebar.vue';
import AppFooter from '@/components/layout/Footer.vue';

export default {
  name: 'SelfReviewPage',
  components: {
    AppSidebar,
    AppFooter
  },
  mounted() {
    document.title = '自审制度 - 武汉天冉网络科技有限公司';
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.static-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  width: 100%;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  position: relative;
  display: inline-block;
  padding-bottom: 15px;
}

.page-header h1:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b81, #ff9eb6);
  border-radius: 3px;
}

.content-container {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.content-text {
  line-height: 1.8;
  color: #444;
  font-size: 16px;
}

.content-text h2 {
  font-size: 22px;
  margin: 25px 0 15px;
  color: #333;
}

.content-text p {
  margin-bottom: 15px;
}

.content-text ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.content-text li {
  margin-bottom: 8px;
}

.update-time {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #999;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .static-page {
    padding: 20px 15px;
  }

  .content-container {
    padding: 20px;
  }
}
</style>
